import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({name: 'numberFr'})
export class numberFrPipe implements PipeTransform {

	constructor(private decimalPipe:DecimalPipe) {}

  transform(value: any): string {
  	if(value != "N/A")
  	{
  		let res = this.decimalPipe.transform(value);
    	return res.replace(',', ' ');
  	}else{
  		return value;
  	}
  	
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/pipes/numberFr.pipe.ts